import { NgModule } from '@angular/core';
import {
    VizFooterComponent,
    VizHeaderComponent,
    VizHttpStatusComponent
} from '@vizientinc/design-system-toolkit';
import { CommonModule } from '@angular/common';

const vizList = [
    VizFooterComponent,
    VizHeaderComponent,
    VizHttpStatusComponent
];

@NgModule({
    imports: [
        CommonModule,
        ...vizList
    ],
    exports: [
        ...vizList
    ]
})
export class AppToolkitModule {
}
